import { AdaptiveLogo } from "@/components/logos/AdaptiveLogo"
import { ADAPTIVE_URL } from "@/constants"
import { useIsDesktop } from "@/utils/useIsDesktop"

export const SymbolLogo = () => {
  const isDesktop = useIsDesktop()
  return (
    <div
      className={`leading-[0] hover:cursor-pointer ${isDesktop ? "pr-2xl" : "pr-3"}`}
    >
      <AdaptiveLogo
        size={1.75}
        role="button"
        onClick={() => {
          window.gtag("event", "outbound_click", {
            destination: ADAPTIVE_URL,
          })
          window.open(ADAPTIVE_URL)
        }}
        withText={false}
      />
    </div>
  )
}
